import React from 'react';

function HeroSection({ topic, setTopic, onExplain }) {
  return (
    <div className="hero-section">
      <h1 className='slider-title'>Clarify</h1>
      <h2 className='logo'>Complex ideas, on your terms</h2>
      <p className="subtitle">
        Adjust complexity with a simple slider, from 5-year-old to PhD level. Get
        personalized learning roadmaps, intuitive metaphors, and interactive quizzes.
      </p>
    </div>
  );
}

export default HeroSection;